(() => {
  const allEventLists = document.querySelectorAll(".wonderful-events");

  allEventLists.forEach((list) => {
    const peopleLabel = list.querySelector(
      ".wonderful-event--filter-slider-value"
    );
    const peopleSlider = list.querySelector(
      ".wonderful-event--filter-slider-input input"
    );

    const modal = list.querySelector(".wonderful-event--modal");
    const typesDomElement = list.querySelector(
      ".wonderful-event--filter-types"
    );
    const citiesDomElement = list.querySelector(
      ".wonderful-event--filter-cities"
    );

    const noEventsFound = list.querySelector(".wonderful-event--error-message");

    const modalTitle = modal.querySelector(".wonderful-event--modal-title");
    const modalHeading = modal.querySelector(".wonderful-event--modal-heading");
    const modalInnerContainer = modal.querySelector(
      ".wonderful-event--modal-inner"
    );
    const modalCloseButton = modal.querySelector(
      ".wonderful-event--modal-close"
    );

    const modalDescription = modal.querySelector(
      ".wonderful-event--modal-description"
    );
    const modalEnquireButton = modal.querySelector(
      ".wonderful-event--enquire-button"
    );
    const downloadKitButton = modal.querySelector(
      ".wonderful-event--download-kit"
    );
    const extraButton = modal.querySelector(".wonderful-event--extra-button");

    const modalHotel = modal.querySelector(
      ".wonderful-event--modal-feature-hotel"
    );
    const modalCity = modal.querySelector(
      ".wonderful-event--modal-feature-city"
    );
    const modalTags = modal.querySelector(
      ".wonderful-event--modal-feature-tags"
    );
    const modalOccupancy = modal.querySelector(
      ".wonderful-event--modal-feature-occupancy"
    );

    const listItems = list.querySelectorAll(".wonderful-event--item");

    const currentFilters = {
      type: "",
      place: "",
      people: 0,
    };

    const onFilterChange = (
      type: "location" | "type" | "occupancy" | "rooms",
      value
    ) => {
      if (type === "occupancy") {
        peopleLabel.innerHTML = value;
      }

      currentFilters[type] = value;

      let blocksHidden = 0;

      listItems.forEach((item) => {
        const dataTarget = item.querySelector(".wonderful-event--item-data");
        let jsonData = {};

        const hideBlock = () => {
          item.classList.add("--hidden");
          blocksHidden++;
        };

        if (dataTarget) {
          jsonData = JSON.parse(dataTarget.innerHTML);

          if (
            currentFilters.type &&
            !jsonData.tags?.includes(currentFilters.type)
          ) {
            return hideBlock();
          }

          if (
            currentFilters.location &&
            jsonData.location !== currentFilters.location
          ) {
            return hideBlock();
          }

          if (
            currentFilters.occupancy &&
            jsonData.occupancy < currentFilters.occupancy
          ) {
            return hideBlock();
          }
        }

        item.classList.remove("--hidden");
      });

      if (blocksHidden === listItems.length) {
        noEventsFound.classList.remove("--hidden");
      } else {
        noEventsFound.classList.add("--hidden");
      }
    };
    
    const openModal = (listItem) => {
     
      const dataTarget = listItem.querySelector(".wonderful-event--item-data");
      if (dataTarget) {
        const jsonData = JSON.parse(dataTarget.innerHTML);

        modalTitle.innerHTML = jsonData.name;
        modalHeading.innerHTML = jsonData.name;
        modalDescription.innerHTML = jsonData.description;

        modalHotel.innerHTML = jsonData.hotelName;
        modalCity.innerHTML = jsonData.suburbLocation;
        modalTags.innerHTML = jsonData.prettyTags;
        modalOccupancy.innerHTML = jsonData.occupancy;

        modalEnquireButton.setAttribute("href", jsonData.enquireUrl);
        downloadKitButton.setAttribute("href", jsonData.downloadUrl);

        if (jsonData.extraButton && extraButton) {
          extraButton.style.display = "inline-block";

          extraButton.innerHTML = jsonData.extraButton.text;
          extraButton.setAttribute("href", jsonData.extraButton.url);
        } else {
          extraButton.style.display = "none";
        }

        modalInnerContainer.style.backgroundImage = `url(${jsonData.image})`;
      }

      modal.classList.add("--open");
    };

    const closeModal = () => {
      modal.classList.remove("--open");
    };

    const checkURLForModal = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const roomParam = urlParams.get("room");
      const propertyParam = urlParams.get("property");

      if (roomParam && propertyParam) {
        console.log("Room and Property params found", roomParam, propertyParam);
        listItems.forEach((listItem) => {
          if (
            listItem.getAttribute("data-title") === roomParam &&
            listItem.getAttribute("data-property") === propertyParam
          ) {
            openModal(listItem);
          }
        });
      }
    };

    // Initialize Choices.js for dropdowns
    new Choices(typesDomElement, {
      searchEnabled: false,
      shouldSort: false,
    });

    new Choices(citiesDomElement, {
      searchEnabled: false,
    });

    typesDomElement.addEventListener("change", (choice) => {
      onFilterChange("type", choice.detail.value);
    });

    citiesDomElement.addEventListener("change", (choice) => {
      onFilterChange("location", choice.detail.value);
    });

    listItems.forEach((listItem) => {
      listItem.addEventListener("click", () => {
        openModal(listItem);
      });
    });

    peopleSlider.addEventListener("input", (e) => {
      onFilterChange("occupancy", e.target.value);
    });

    modal.addEventListener("click", () => {
      closeModal();
    });

    modalInnerContainer.addEventListener("click", (e) => {
      e.stopPropagation();

      return false;
    });

    modalCloseButton.addEventListener("click", () => {
      closeModal();
    });

    // Check URL for specific room and property parameters after DOM is ready
    document.addEventListener("DOMContentLoaded", checkURLForModal);
  });
})();
